import { useLayoutEffect } from 'react';
import useFlags from '@/hooks/useFlags';
import SlideshowImage from 'modules/SlideshowImage';

type ImageModel = {
  image_id: number;
  zoom_type: string;
};

interface ImageZoomProps {
  container: string;
  context: 'SlideShow';
  imageModels: ImageModel[];
}

const ImageZoom = ({ container: selector = 'body', context, imageModels }: ImageZoomProps) => {
  const { displaySlideGroupHeaders } = useFlags();
  const useZoomIcon = context === 'SlideShow' && displaySlideGroupHeaders;

  const loadSlideshowImages = () => {
    const container = document.querySelector(selector);

    container.querySelectorAll('[data-zoomurl]').forEach((img) => {
      const match = (img as HTMLImageElement).src.match(/\/(\d+)\//);
      const number = match ? match[1] : null;

      const imageModel = imageModels.find(im => im.image_id.toString() === number?.toString());

      if (!imageModel?.zoom_type && img.className !== 'vocabImage') return;
      if (img.getAttribute('init')) return;

      const slideshowImage = new SlideshowImage();
      slideshowImage.init(img, useZoomIcon);
    });
  };

  useLayoutEffect(() => {
    loadSlideshowImages();

    setTimeout(() => {
      loadSlideshowImages();
    }, 2000);
  }, [selector, imageModels]);

  return null;
};

export default ImageZoom;
